<template>
    <section class="work">
      <div class="work-items">
        <FadeUp
          :src="obra.fotoFile"
          :src-placeholder="require('@/assets/img/default-img.jpg')"
          @load="imageLoaded()"/>
      </div>
      <h1 class="bcLiguria">{{ obra.nombre }}</h1>
      <div class="work-info">
        <h3 class="work-info-title bcLiguria">Ubicación</h3>
        <p class="work-info-description">{{ obra.ubicacion }}</p>
        <h3 class="work-info-title bcLiguria">Estudio de Arquitectura</h3>
        <p class="work-info-description">{{ obra.estudio }}</p>
        <h3 class="work-info-title bcLiguria">Producto:</h3>
        <p>{{ obra.productos.map(producto => producto.nombre).join(' / ') }}</p>
        <h3 class="work-info-title bcLiguria">Aplicación:</h3>
        <div v-if="obra.aplicaciones">
          <p>
            <span v-for="(aplicacion, index) in obra.aplicaciones" :key="index">
              <u>{{ aplicacion.nombre }}</u>
              <span v-if="index < obra.aplicaciones.length - 1"> / </span>
            </span>
          </p>
        </div>

        <div v-else>
          <p>{{ $i18n.locale === 'es' ? 'Sin aplicación asociada' : 'No application available' }}</p>
        </div>
        <h3 class="work-info-title bcLiguria">Materialidad:</h3>

        <div v-if="obra.materiales">
          <p>
            <span v-for="(material, index) in obra.materiales" :key="index">
              <u>{{ material.nombre }}</u>
              <span v-if="index < obra.materiales.length - 1"> / </span>
            </span>
          </p>
        </div>

        <div v-else>
          <p>{{ $i18n.locale === 'es' ? 'Sin material asociado' : 'No material available' }}</p>
        </div>
      </div>

      <div class="work-fotos">
        <GridWork v-for="foto in obra.fotos" :key="foto" :foto="foto" />
      </div>
    </section>
</template>
<script>
import ObrasService from '../services/ObrasService'
import { EventBus } from '@/event-bus'
import GridWork from '@/components/DinamicGrid/Work.vue'
import FadeUp from '@/components/lazy-load-images/FadeImage'
export default {
  name: 'work',
  components: {
    GridWork,
    FadeUp
  },
  data () {
    return {
      obra: [],
      fotos: [],
      showLoading: true
    }
  },
  methods: {
    getObras () {
      const service = new ObrasService()
      const id = this.$route.params.work.split('-')[0]
      service.findAll({ id }, (response) => {
        this.obra = response
      })
    },
    getFotos () {
      this.obra.forEach(obra => {
        obra.fotos.forEach(foto => {
          this.fotos.push(foto)
        })
      })
    }
  },
  mounted () {
    EventBus.$emit('showTitlePage', this.obra.nombre)
    this.getObras()
  }
}
</script>
<style lang="scss" scoped>
  .work{
    position: relative;
    background: #1A1A1A;
    color: white;
    // margin-top: calc(var(--main-space) * 4);
    gap: 1.5em;
    h1{
      font-size: 50px;
      padding-inline: var(--main-space);
    }
    &-items{
      width: 100%;
      margin: auto;
      position: relative;
      img{
        width: 100vw;
        height: 100vh;
        object-fit: cover;
        object-position: center;
        border: none !important;
        margin-block-end: calc(var(--main-space) * 2);
      }
    }
    &-info{
      display: flex;
      flex-direction: column;
      padding: 50px var(--main-space) 110px var(--main-space);
      h3{
        font-size: 20px;
        margin-bottom: calc(var(--main-space) / 3);
        color: $footer-text;
      }
      p, u{
        font-size: 20px;
        margin-bottom: calc(var(--main-space) * 0.75);
      }
    }

    &-fotos{
      width: 100%;
      padding-inline: var(--main-space);
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }
  }
  @media (max-width: 768px){
    .work{
      h1{
        font-size: 32px;
      }
      &-items{
        img{
          width: 100%;
          height: auto;
          margin-top: 120px;
        }
      }
      &-info{
        padding: 50px var(--main-space) 70px var(--main-space) !important;
        h3, p, u{
          font-size: 18px;
        }
      }
      &-fotos{
        margin-top: calc(var(--main-space) * 1.5);
        width: 100%;
        padding: 0;
        display: grid;
        grid-template-columns: 1fr;
        gap: 10px;
        .work-foto{
          height: auto;
        }
      }
    }
  }
</style>
